import UserNote from 'owa-mail-store/lib/store/schema/UserNote';
import { lazyGetItemProperties } from 'owa-get-item-manager';
import { featureId, USER_NOTE_DATA_PROPERTY_NAME } from '../utils/userNoteItemPropertyEntry';
import { ClientItem } from 'owa-mail-store';
import Item from 'owa-service/lib/contract/Item';
import { mutatorAction } from 'satcheljs';
import getExtendedPropertyValue from 'owa-mail-store/lib/utils/getExtendedPropertyValue';

export default async function initUserNoteDataForItem(item: ClientItem) {
    const itemUserNotes = (await loadUserNoteDataForItem(item)) || [];
    setUserNoteDataForItem(item, itemUserNotes);
}

async function loadUserNoteDataForItem(item: ClientItem): Promise<UserNote[]> {
    let updatedItem: Item = null;

    try {
        const getItemProperties = await lazyGetItemProperties.import();
        updatedItem = await getItemProperties(item.ItemId.Id, featureId);
    } catch (e) {
        // On a network error we just won't have note data for this item
    }

    if (updatedItem) {
        const userNoteValue = getExtendedPropertyValue(
            updatedItem,
            null /*tag*/,
            USER_NOTE_DATA_PROPERTY_NAME
        );
        return userNoteValue ? (JSON.parse(userNoteValue) as UserNote[]) : null;
    }

    return null;
}

const setUserNoteDataForItem = mutatorAction(
    'setUserNoteDataForItem',
    (item: ClientItem, userNoteData: UserNote[]) => {
        item.userNoteData = userNoteData;
    }
);
